import { render, staticRenderFns } from "./WafInstancesDelete.vue?vue&type=template&id=12c6db78&"
import script from "./WafInstancesDelete.vue?vue&type=script&lang=js&"
export * from "./WafInstancesDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports